import {getData, LOGIN, setData} from "../storage";


export const updateJWTToken = (create_broadcast_response, callback) => {

    getData(LOGIN).then((data) => {
        /**
         * returns the data in the form
         * {
                        api_token: "",
                        firebase_token: "",
                        is_broadcaster: true,
                        token: "",
                        ttl: 1530292093
                    }
         */

        if (create_broadcast_response !== null &&
            create_broadcast_response.hasOwnProperty("data") &&
            create_broadcast_response.data !== null &&
            create_broadcast_response.data.hasOwnProperty("jwt_token") && !Array.isArray(create_broadcast_response.data.jwt_token)) {


            setData(LOGIN, {
                ...data,
                // token: create_broadcast_response.data.token
            }, () => {
                /**
                 * dispatch an action and pass the relevant Tokbox details i.e
                 * {
                            "session_id": "",
                            "token": "",
                            "id": 6,
                            "time_to_start_the_broadcast": 15,
                            "jwt_token": ""
		                 }
                 */
                if (callback !== null && typeof callback === "function") {
                    callback();
                }
            });
        }else{
            if (callback !== null && typeof callback === "function") {
                callback();
            }
        }

    });
}